var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs.length > 1)?_c('div',{staticClass:"tab"},[_c('div',{ref:"tabContainer",staticClass:"tab-header",class:{ 'scrollable': _vm.isScrollable },on:{"mousedown":_vm.onMouseDown,"touchstart":_vm.onTouchStart}},_vm._l((_vm.tabs),function(item,index){return _c('div',{key:`${item.strategyId}${index}`,staticClass:"tab-header-item",class:{ active: _vm.activeIndex === index },style:({'--activeColor':_vm.activeColor,
        '--deActiveColor':_vm.deActiveColor,
        '--deActiveBg':`url(${_vm.deActiveBg})`,
        '--activeBg':`url(${_vm.activeBg})`,
        '--width':_vm.width,
        '--height':_vm.height,
        '--fontSize':_vm.fontSize,
        '--marginRight':_vm.tabs.length > 2 ? '8px' : '45px'
        }),on:{"click":function($event){return _vm.scrollToCenter(index)}}},[_vm._v(" "+_vm._s(_vm.limitText(item.labelName))+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }